var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container__nims"},[_c('p',{staticClass:"title"},[_vm._v("환불정보를 정확히 입력해주세요.")]),(_vm.isRender)?_c('nims-ems-step01-template',{on:{"next-step-btn-click":_vm.goNextStep},model:{value:(_vm.formState),callback:function ($$v) {_vm.formState=$$v},expression:"formState"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }